export default () => ({
  restrict: "A",
  link(scope, $elm, attrs) {
    var idToScroll = attrs.href;
    $elm.on("click", function () {
      var $target;
      if (idToScroll) {
        $target = $(idToScroll);
      } else {
        $target = $elm;
      }
      $("body").animate({ scrollTop: $target.offset().top }, "slow");
    });
  },
});
